import { HashLink as Link } from "react-router-hash-link";
import scrollToTop from "../components/scrollToTop";
import Form from "../components/form";
import FormattedText, { withEllipsis } from "../components/formattedText";
import {
  useDevotionals,
  DEFAULT_CARD_IMG,
  DEFAULT_HERO_IMG,
} from "../data/devotionals";

const ExegesisPage = () => {
  const { entries, loading, error } = useDevotionals();
  const latest = entries[0]; // newest first
  const others = entries.slice(1);

  return (
    <>
      <div className="page-container exegesis-page-container">
        {(loading || error) && (
          <div className="sect2">
            <p>{loading ? "Loading entries…" : error}</p>
          </div>
        )}
        {latest && (
          <>
            <div className="hero">
              <img src={latest.coverImage || DEFAULT_HERO_IMG} alt="" />{" "}
              <div className="datentitle">
                <h1>{latest.title}</h1>
              </div>
            </div>
            <div className="latest-entry-intro">
              <div>
                <FormattedText text={withEllipsis(latest.introParagraph)} />
              </div>
              <Link
                to={`/exegesis/${latest.slug || latest.id}`}
                onClick={scrollToTop}
              >
                <button>Read more</button>
              </Link>
            </div>
          </>
        )}
        {others.length > 0 && (
          <div className="sect2">
            <h2>More Biblical exegesis entries</h2>
            <div className="dev-previews-container">
              {others.map((entry) => (
                <div className="devotional-preview-container" key={entry.id}>
                  <img src={entry.coverImage || DEFAULT_CARD_IMG} alt="" />
                  <h3>{entry.title}</h3>
                  <div>
                    <FormattedText text={withEllipsis(entry.introParagraph)} />
                  </div>
                  <Link
                    to={`/exegesis/${entry.slug || entry.id}`}
                    onClick={scrollToTop}
                  >
                    <button>Read more</button>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="sect3">
          <div className="form">
            <div className="intro">
              <h2>Sign up to our mailing list!</h2>
              <span>
                Join our community to gain exclusive access to new release
                notifications, announcements website updates and more!
              </span>
            </div>
            <Form formId="Mailing" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ExegesisPage;